import {
  getBaseApiHelper,
} from '../../common/utils/apiHelpers';

export const GET_ACCOUNT_PERMISSIONS_REQUEST = 'GET_ACCOUNT_PERMISSIONS_REQUEST';
export const GET_ACCOUNT_PERMISSIONS_FAILURE = 'GET_ACCOUNT_PERMISSIONS_FAILURE';
export const GET_ACCOUNT_PERMISSIONS_SUCCESS = 'GET_ACCOUNT_PERMISSIONS_SUCCESS';

export const POST_ACCOUNT_PERMISSIONS_SUCCESS = 'POST_ACCOUNT_PERMISSIONS_SUCCESS';



const getAccountPermissionsRequest = () => ({
  type: GET_ACCOUNT_PERMISSIONS_REQUEST,
  isFetching: true
});

const getAccountPermissionsSuccess = payload => ({
  type: GET_ACCOUNT_PERMISSIONS_SUCCESS,
  payload
});

const getAccountPermissionsFailure = payloadError => ({
  type: GET_ACCOUNT_PERMISSIONS_FAILURE,
  error: payloadError
});

export const getAccountPermissions = (accountId) => {
  return dispatch => {
    dispatch(getAccountPermissionsRequest());
    return getBaseApiHelper(`/account_permissions?permissioned=${accountId}`)
      .then(response => {
        return dispatch(getAccountPermissionsSuccess(response.data));
      })
      .catch(rejected => {
        dispatch(getAccountPermissionsFailure(rejected.response));
        return Promise.reject({ error: rejected.response });
      });
  };
}

export const postAccountPermissionsSuccess = payload => ({
  type: POST_ACCOUNT_PERMISSIONS_SUCCESS,
  payload
});
